var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import createSagaMiddleware from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { MODE } from '../define/env';
import webStorage from '../helpers/webStorage';
import { getApiSagas, getAuthSagas } from './saga';
export const getSagaMiddleware = (apiClient) => {
    const sagaMiddleware = createSagaMiddleware();
    const saga = function* rootSaga() {
        yield all([getApiSagas({ apiClient }), getAuthSagas()].map(fork));
    };
    const sagaRun = () => {
        // Sagaの起動
        sagaMiddleware.run(saga);
    };
    return {
        sagaMiddleware,
        sagaRun,
    };
};
export const getReduxLogger = () => __awaiter(void 0, void 0, void 0, function* () {
    const returnObj = {
        compose: null,
        logger: null,
    };
    if (MODE !== 'development') {
        return returnObj;
    }
    /* eslint-disable */
    // Redux logger
    const IS_USE_REDUX_LOGGER = 'development:IS_USE_REDUX_LOGGER';
    const isUseReduxLogger = !!webStorage.get(IS_USE_REDUX_LOGGER);
    if (isUseReduxLogger) {
        const { logger } = yield import(
        /* webpackChunkName: 'redux-logger' */ 'redux-logger');
        returnObj.logger = logger;
    }
    webStorage.set(IS_USE_REDUX_LOGGER, isUseReduxLogger);
    // Redux devtool, https://github.com/zalmoxisus/redux-devtools-extension
    if (window.devToolsExtension) {
        returnObj.compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }
    /* eslint-enable */
    return returnObj;
});
